module.exports = "https://cdn.hellotech.com/client-assets/logo_fortune_80ed59b54653c9b3423b36f5bf4f6d10.png";